var countryList = {au: 'Australia', us: 'United States', nz: 'New Zealand', id: 'Indonesia'}
if (location.host === 'eu-advertiser.opentop.com') {
  countryList = {es: 'Spain'}
}

// date constant
const dayAbbreviation = ['S', 'M', 'T', 'W', 'T', 'F', 'S']
const dayList = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
const monthList = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
  'Oct', 'Nov', 'Dec']
const monthLongList = ['January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December']
export default {
  dollarList: {'au': '$', 'nz': '$', 'uk': '£', 'us': '$', 'es': '€', 'aud': '$', 'nzd': '$', 'ukp': '£', 'usd': '$', 'eur': '€', 'id': '$', 'idr': '$', '': ''},
  countryList: countryList, // {au: 'Australia', nz: 'New Zealand', uk: 'United Kingdom', us: 'United States', es: 'Spain'}
  stateList: {
    au: {'ACT': 'Australian Capital Territory', 'NSW': 'New South Wales', 'NT': 'Northern Territory', 'QLD': 'Queensland', 'SA': 'South Australia', 'TAS': 'Tasmania', 'VIC': 'Victoria', 'WA': 'Western Australia'},
    us: {'AL': 'Alabama', 'AK': 'Alaska', 'AS': 'American Samoa', 'AZ': 'Arizona', 'AR': 'Arkansas', 'CA': 'California', 'CO': 'Colorado', 'CT': 'Connecticut', 'DE': 'Delaware', 'DC': 'District Of Columbia', 'FM': 'Federated States Of Micronesia', 'FL': 'Florida', 'GA': 'Georgia', 'GU': 'Guam', 'HI': 'Hawaii', 'ID': 'Idaho', 'IL': 'Illinois', 'IN': 'Indiana', 'IA': 'Iowa', 'KS': 'Kansas', 'KY': 'Kentucky', 'LA': 'Louisiana', 'ME': 'Maine', 'MH': 'Marshall Islands', 'MD': 'Maryland', 'MA': 'Massachusetts', 'MI': 'Michigan', 'MN': 'Minnesota', 'MS': 'Mississippi', 'MO': 'Missouri', 'MT': 'Montana', 'NE': 'Nebraska', 'NV': 'Nevada', 'NH': 'New Hampshire', 'NJ': 'New Jersey', 'NM': 'New Mexico', 'NY': 'New York', 'NC': 'North Carolina', 'ND': 'North Dakota', 'MP': 'Northern Mariana Islands', 'OH': 'Ohio', 'OK': 'Oklahoma', 'OR': 'Oregon', 'PW': 'Palau', 'PA': 'Pennsylvania', 'PR': 'Puerto Rico', 'RI': 'Rhode Island', 'SC': 'South Carolina', 'SD': 'South Dakota', 'TN': 'Tennessee', 'TX': 'Texas', 'UT': 'Utah', 'VT': 'Vermont', 'VI': 'Virgin Islands', 'VA': 'Virginia', 'WA': 'Washington', 'WV': 'West Virginia', 'WI': 'Wisconsin', 'WY': 'Wyoming'},
    nz: {'auckland': 'Auckland', 'bay of plenty': 'Bay of Plenty', 'canterbury': 'Canterbury', 'gisborne': 'Gisborne', 'hawkes bay': 'Hawkes Bay', 'nelson': 'Nelson', 'northland': 'Northland', 'marlborough': 'Marlborough', 'manawatu-whanganui': 'Manawatu-Whanganui', 'otago': 'Otago', 'southland': 'Southland', 'taranaki': 'Taranaki', 'tasman': 'Tasman', 'waikato': 'Waikato', 'wellington': 'Wellington', 'west coast': 'West Coast'},
    es: {'A Coruña': 'A Coruña', 'Álava': 'Álava', 'Albacete': 'Albacete', 'Alicante': 'Alicante', 'Almería': 'Almería', 'Asturias': 'Asturias', 'Ávila': 'Ávila', 'Badajoz': 'Badajoz', 'Barcelona': 'Barcelona', 'Burgos': 'Burgos', 'Cáceres': 'Cáceres', 'Cádiz': 'Cádiz', 'Cantabria': 'Cantabria', 'Castellón': 'Castellón', 'Ceuta': 'Ceuta', 'Ciudad Real': 'Ciudad Real', 'Córdoba': 'Córdoba', 'Cuenca': 'Cuenca', 'Girona': 'Girona', 'Granada': 'Granada', 'Guadalajara': 'Guadalajara', 'Guipúzcoa': 'Guipúzcoa', 'Huelva': 'Huelva', 'Huesca': 'Huesca', 'Islas Baleares': 'Islas Baleares', 'Jaén': 'Jaén', 'La Rioja': 'La Rioja', 'Las Palmas': 'Las Palmas', 'León': 'León', 'Lleida': 'Lleida', 'Lugo': 'Lugo', 'Madrid': 'Madrid', 'Málaga': 'Málaga', 'Melilla': 'Melilla', 'Murcia': 'Murcia', 'Navarra': 'Navarra', 'Ourense': 'Ourense', 'Palencia': 'Palencia', 'Pontevedra': 'Pontevedra', 'Salamanca': 'Salamanca', 'Santa Cruz de Tenerife': 'Santa Cruz de Tenerife', 'Segovia': 'Segovia', 'Sevilla': 'Sevilla', 'Soria': 'Soria', 'Tarragona': 'Tarragona', 'Teruel': 'Teruel', 'Toledo': 'Toledo', 'Valencia': 'Valencia', 'Valladolid': 'Valladolid', 'Vizcaya': 'Vizcaya', 'Zamora': 'Zamora', 'Zaragoza': 'Zaragoza'}
  },
  timeZone: {
    au: {
      'Australia/Adelaide': 'Australia/Adelaide (UTC/GMT +09:30)',
      'Australia/Brisbane': 'Australia/Brisbane (UTC/GMT +10:00)',
      'Australia/Broken_Hill': 'Australia/Broken_Hill (UTC/GMT +09:30)',
      'Australia/Currie': 'Australia/Currie (UTC/GMT +10:00)',
      'Australia/Darwin': 'Australia/Darwin (UTC/GMT +09:30)',
      'Australia/Eucla': 'Australia/Eucla (UTC/GMT +08:45)',
      'Australia/Hobart': 'Australia/Hobart (UTC/GMT +11:00)',
      'Australia/Lindeman': 'Australia/Lindeman (UTC/GMT +10:00)',
      'Australia/Lord_Howe': 'Australia/Lord_Howe (UTC/GMT +10:00)',
      'Australia/Melbourne': 'Australia/Melbourne (UTC/GMT +10:00)',
      'Australia/Perth': 'Australia/Perth (UTC/GMT +08:00)',
      'Australia/Sydney': 'Australia/Sydney (UTC/GMT +10:00)'
    },
    us: {
      'America/Adak': 'America/Adak (UTC/GMT -11:00)',
      'America/Anchorage': 'America/Anchorage (UTC/GMT -10:00)',
      'America/Anguilla': 'America/Anguilla (UTC/GMT -04:00)',
      'America/Antigua': 'America/Antigua (UTC/GMT -04:00)',
      'America/Araguaina': 'America/Araguaina (UTC/GMT -03:00)',
      'America/Argentina/Buenos_Aires': 'America/Argentina/Buenos_Aires (UTC/GMT -03:00)',
      'America/Argentina/Catamarca': 'America/Argentina/Catamarca (UTC/GMT -03:00)',
      'America/Argentina/Cordoba': 'America/Argentina/Cordoba (UTC/GMT -03:00)',
      'America/Argentina/Jujuy': 'America/Argentina/Jujuy (UTC/GMT -03:00)',
      'America/Argentina/La_Rioja': 'America/Argentina/La_Rioja (UTC/GMT -03:00)',
      'America/Argentina/Mendoza': 'America/Argentina/Mendoza (UTC/GMT -03:00)',
      'America/Argentina/Rio_Gallegos': 'America/Argentina/Rio_Gallegos (UTC/GMT -03:00)',
      'America/Argentina/Salta': 'America/Argentina/Salta (UTC/GMT -03:00)',
      'America/Argentina/San_Juan': 'America/Argentina/San_Juan (UTC/GMT -03:00)',
      'America/Argentina/San_Luis': 'America/Argentina/San_Luis (UTC/GMT -03:00)',
      'America/Argentina/Tucuman': 'America/Argentina/Tucuman (UTC/GMT -03:00)',
      'America/Argentina/Ushuaia': 'America/Argentina/Ushuaia (UTC/GMT -03:00)',
      'America/Aruba': 'America/Aruba (UTC/GMT -04:00)',
      'America/Asuncion': 'America/Asuncion (UTC/GMT -04:00)',
      'America/Atikokan': 'America/Atikokan (UTC/GMT -05:00)',
      'America/Bahia': 'America/Bahia (UTC/GMT -03:00)',
      'America/Bahia_Banderas': 'America/Bahia_Banderas (UTC/GMT -08:00)',
      'America/Barbados': 'America/Barbados (UTC/GMT -04:00)',
      'America/Belem': 'America/Belem (UTC/GMT -03:00)',
      'America/Belize': 'America/Belize (UTC/GMT -06:00)',
      'America/Blanc-Sablon': 'America/Blanc-Sablon (UTC/GMT -04:00)',
      'America/Boa_Vista': 'America/Boa_Vista (UTC/GMT -04:00)',
      'America/Bogota': 'America/Bogota (UTC/GMT -05:00)',
      'America/Boise': 'America/Boise (UTC/GMT -07:00)',
      'America/Cambridge_Bay': 'America/Cambridge_Bay (UTC/GMT -07:00)',
      'America/Campo_Grande': 'America/Campo_Grande (UTC/GMT -04:00)',
      'America/Cancun': 'America/Cancun (UTC/GMT -06:00)',
      'America/Caracas': 'America/Caracas (UTC/GMT -04:00)',
      'America/Cayenne': 'America/Cayenne (UTC/GMT -03:00)',
      'America/Cayman': 'America/Cayman (UTC/GMT -05:00)',
      'America/Chicago': 'America/Chicago (UTC/GMT -06:00)',
      'America/Chihuahua': 'America/Chihuahua (UTC/GMT -06:00)',
      'America/Costa_Rica': 'America/Costa_Rica (UTC/GMT -06:00)',
      'America/Creston': 'America/Creston (UTC/GMT -07:00)',
      'America/Cuiaba': 'America/Cuiaba (UTC/GMT -04:00)',
      'America/Curacao': 'America/Curacao (UTC/GMT -04:00)',
      'America/Danmarkshavn': 'America/Danmarkshavn (UTC/GMT -03:00)',
      'America/Dawson': 'America/Dawson (UTC/GMT -09:00)',
      'America/Dawson_Creek': 'America/Dawson_Creek (UTC/GMT -08:00)',
      'America/Denver': 'America/Denver (UTC/GMT -07:00)',
      'America/Detroit': 'America/Detroit (UTC/GMT -05:00)',
      'America/Dominica': 'America/Dominica (UTC/GMT -04:00)',
      'America/Edmonton': 'America/Edmonton (UTC/GMT -07:00)',
      'America/Eirunepe': 'America/Eirunepe (UTC/GMT -05:00)',
      'America/El_Salvador': 'America/El_Salvador (UTC/GMT -06:00)',
      'America/Fort_Nelson': 'America/Fort_Nelson (UTC/GMT -08:00)',
      'America/Fortaleza': 'America/Fortaleza (UTC/GMT -03:00)',
      'America/Glace_Bay': 'America/Glace_Bay (UTC/GMT -04:00)',
      'America/Godthab': 'America/Godthab (UTC/GMT -03:00)',
      'America/Goose_Bay': 'America/Goose_Bay (UTC/GMT -04:00)',
      'America/Grand_Turk': 'America/Grand_Turk (UTC/GMT -05:00)',
      'America/Grenada': 'America/Grenada (UTC/GMT -04:00)',
      'America/Guadeloupe': 'America/Guadeloupe (UTC/GMT -04:00)',
      'America/Guatemala': 'America/Guatemala (UTC/GMT -06:00)',
      'America/Guayaquil': 'America/Guayaquil (UTC/GMT -05:00)',
      'America/Guyana': 'America/Guyana (UTC/GMT -03:45)',
      'America/Halifax': 'America/Halifax (UTC/GMT -04:00)',
      'America/Havana': 'America/Havana (UTC/GMT -05:00)',
      'America/Hermosillo': 'America/Hermosillo (UTC/GMT -08:00)',
      'America/Indiana/Indianapolis': 'America/Indiana/Indianapolis (UTC/GMT -05:00)',
      'America/Indiana/Knox': 'America/Indiana/Knox (UTC/GMT -06:00)',
      'America/Indiana/Marengo': 'America/Indiana/Marengo (UTC/GMT -05:00)',
      'America/Indiana/Petersburg': 'America/Indiana/Petersburg (UTC/GMT -06:00)',
      'America/Indiana/Tell_City': 'America/Indiana/Tell_City (UTC/GMT -05:00)',
      'America/Indiana/Vevay': 'America/Indiana/Vevay (UTC/GMT -05:00)',
      'America/Indiana/Vincennes': 'America/Indiana/Vincennes (UTC/GMT -05:00)',
      'America/Indiana/Winamac': 'America/Indiana/Winamac (UTC/GMT -05:00)',
      'America/Inuvik': 'America/Inuvik (UTC/GMT -08:00)',
      'America/Iqaluit': 'America/Iqaluit (UTC/GMT -05:00)',
      'America/Jamaica': 'America/Jamaica (UTC/GMT -05:00)',
      'America/Juneau': 'America/Juneau (UTC/GMT -08:00)',
      'America/Kentucky/Louisville': 'America/Kentucky/Louisville (UTC/GMT -05:00)',
      'America/Kentucky/Monticello': 'America/Kentucky/Monticello (UTC/GMT -06:00)',
      'America/Kralendijk': 'America/Kralendijk (UTC/GMT -04:00)',
      'America/La_Paz': 'America/La_Paz (UTC/GMT -04:00)',
      'America/Lima': 'America/Lima (UTC/GMT -05:00)',
      'America/Los_Angeles': 'America/Los_Angeles (UTC/GMT -08:00)',
      'America/Lower_Princes': 'America/Lower_Princes (UTC/GMT -04:00)',
      'America/Maceio': 'America/Maceio (UTC/GMT -03:00)',
      'America/Managua': 'America/Managua (UTC/GMT -06:00)',
      'America/Manaus': 'America/Manaus (UTC/GMT -04:00)',
      'America/Marigot': 'America/Marigot (UTC/GMT -04:00)',
      'America/Martinique': 'America/Martinique (UTC/GMT -04:00)',
      'America/Matamoros': 'America/Matamoros (UTC/GMT -06:00)',
      'America/Mazatlan': 'America/Mazatlan (UTC/GMT -08:00)',
      'America/Menominee': 'America/Menominee (UTC/GMT -05:00)',
      'America/Merida': 'America/Merida (UTC/GMT -06:00)',
      'America/Metlakatla': 'America/Metlakatla (UTC/GMT -08:00)',
      'America/Mexico_City': 'America/Mexico_City (UTC/GMT -06:00)',
      'America/Miquelon': 'America/Miquelon (UTC/GMT -04:00)',
      'America/Moncton': 'America/Moncton (UTC/GMT -04:00)',
      'America/Monterrey': 'America/Monterrey (UTC/GMT -06:00)',
      'America/Montevideo': 'America/Montevideo (UTC/GMT -03:00)',
      'America/Montserrat': 'America/Montserrat (UTC/GMT -04:00)',
      'America/Nassau': 'America/Nassau (UTC/GMT -05:00)',
      'America/New_York': 'America/New_York (UTC/GMT -05:00)',
      'America/Nipigon': 'America/Nipigon (UTC/GMT -05:00)',
      'America/Nome': 'America/Nome (UTC/GMT -11:00)',
      'America/Noronha': 'America/Noronha (UTC/GMT -02:00)',
      'America/North_Dakota/Beulah': 'America/North_Dakota/Beulah (UTC/GMT -07:00)',
      'America/North_Dakota/Center': 'America/North_Dakota/Center (UTC/GMT -07:00)',
      'America/North_Dakota/New_Salem': 'America/North_Dakota/New_Salem (UTC/GMT -07:00)',
      'America/Ojinaga': 'America/Ojinaga (UTC/GMT -06:00)',
      'America/Panama': 'America/Panama (UTC/GMT -05:00)',
      'America/Pangnirtung': 'America/Pangnirtung (UTC/GMT -04:00)',
      'America/Paramaribo': 'America/Paramaribo (UTC/GMT -03:30)',
      'America/Phoenix': 'America/Phoenix (UTC/GMT -07:00)',
      'America/Port-au-Prince': 'America/Port-au-Prince (UTC/GMT -05:00)',
      'America/Port_of_Spain': 'America/Port_of_Spain (UTC/GMT -04:00)',
      'America/Porto_Velho': 'America/Porto_Velho (UTC/GMT -04:00)',
      'America/Puerto_Rico': 'America/Puerto_Rico (UTC/GMT -04:00)',
      'America/Punta_Arenas': 'America/Punta_Arenas (UTC/GMT -03:00)',
      'America/Rainy_River': 'America/Rainy_River (UTC/GMT -06:00)',
      'America/Rankin_Inlet': 'America/Rankin_Inlet (UTC/GMT -06:00)',
      'America/Recife': 'America/Recife (UTC/GMT -03:00)',
      'America/Regina': 'America/Regina (UTC/GMT -06:00)',
      'America/Resolute': 'America/Resolute (UTC/GMT -06:00)',
      'America/Rio_Branco': 'America/Rio_Branco (UTC/GMT -05:00)',
      'America/Santarem': 'America/Santarem (UTC/GMT -04:00)',
      'America/Santiago': 'America/Santiago (UTC/GMT -03:00)',
      'America/Santo_Domingo': 'America/Santo_Domingo (UTC/GMT -04:30)',
      'America/Sao_Paulo': 'America/Sao_Paulo (UTC/GMT -03:00)',
      'America/Scoresbysund': 'America/Scoresbysund (UTC/GMT -02:00)',
      'America/Sitka': 'America/Sitka (UTC/GMT -08:00)',
      'America/St_Barthelemy': 'America/St_Barthelemy (UTC/GMT -04:00)',
      'America/St_Johns': 'America/St_Johns (UTC/GMT -03:30)',
      'America/St_Kitts': 'America/St_Kitts (UTC/GMT -04:00)',
      'America/St_Lucia': 'America/St_Lucia (UTC/GMT -04:00)',
      'America/St_Thomas': 'America/St_Thomas (UTC/GMT -04:00)',
      'America/St_Vincent': 'America/St_Vincent (UTC/GMT -04:00)',
      'America/Swift_Current': 'America/Swift_Current (UTC/GMT -07:00)',
      'America/Tegucigalpa': 'America/Tegucigalpa (UTC/GMT -06:00)',
      'America/Thule': 'America/Thule (UTC/GMT -04:00)',
      'America/Thunder_Bay': 'America/Thunder_Bay (UTC/GMT -05:00)',
      'America/Tijuana': 'America/Tijuana (UTC/GMT -08:00)',
      'America/Toronto': 'America/Toronto (UTC/GMT -05:00)',
      'America/Tortola': 'America/Tortola (UTC/GMT -04:00)',
      'America/Vancouver': 'America/Vancouver (UTC/GMT -08:00)',
      'America/Whitehorse': 'America/Whitehorse (UTC/GMT -08:00)',
      'America/Winnipeg': 'America/Winnipeg (UTC/GMT -06:00)',
      'America/Yakutat': 'America/Yakutat (UTC/GMT -09:00)',
      'America/Yellowknife': 'America/Yellowknife (UTC/GMT -07:00)'
    },
    es: {
      'Europe/Madrid': 'Europe/Madrid (UTC/GMT +01:00)'
    },
    nz: {
      'Pacific/Auckland': 'Pacific/Auckland (UTC/GMT +12:00)'
    },
    id: {
      'Asia/Jakarta': 'Jakarta (UTC/GMT +07:00)',
      'Asia/Ujung_Pandang': 'Central Indonesian Time (UTC/GMT +08:00)',
      'Asia/Jayapura': 'Jayapura (UTC/GMT +09:00)'
    }
  },
  defaultTimeZone: {
    au: {value: 'Australia/Melbourne', text: 'Australia/Melbourne (UTC/GMT +10:00)'},
    us: {value: 'America/New_York', text: 'America/New_York (UTC/GMT -05:00)'},
    es: {value: 'Europe/Madrid', text: 'Europe/Madrid (UTC/GMT +01:00'},
    nz: {value: 'Pacific/Auckland', text: 'Pacific/Auckland (UTC/GMT +12:00'},
    id: {value: 'Asia/Ujung_Pandang', text: 'Central Indonesian Time (UTC/GMT +08:00)'}
  },
  campaignCategory: {
    // '': 'Select Industry',
    'Accommodation': 'Accommodation',
    'Alcohol': 'Alcohol',
    'Automotive': 'Automotive',
    'Banking & Finance': 'Banking & Finance',
    'Bar & Restaurant': 'Bar & Restaurant',
    'Cafe': 'Cafe',
    'Charity': 'Charity',
    'Childcare': 'Childcare',
    'Consulting': 'Consulting',
    'Cruises': 'Cruises',
    'Deals': 'Deals',
    'Digital Printing': 'Digital Printing',
    'Education': 'Education',
    'Energy': 'Energy',
    'Entertainment': 'Entertainment',
    'Events': 'Events',
    'Finance': 'Finance',
    'Food': 'Food',
    'Gambling & Lottery': 'Gambling & Lottery',
    'Health & Beauty': 'Health & Beauty',
    'Health & Fitness': 'Health & Fitness',
    // Insurance
    'Insurance': 'Insurance:',
    'Automotive Insurance': 'Automotive',
    'Insurance Comparison': 'Comparison',
    'Funeral Insurance': 'Funeral',
    'Health Insurance': 'Health',
    'Life Insurance': 'Life',
    'Other Insurance': 'Other',
    'Travel Insurance': 'Travel',

    'Online Dating': 'Online Dating',
    'Other': 'Other',
    'Real Estate': 'Real Estate',
    // Retail
    'Retail': 'Retail:',
    'Camping Retail': 'Camping',
    'Department Store Retail': 'Department Store',
    'Electrical Retail': 'Electrical',
    'Fashion Retail': 'Fashion',
    'Hardware Retail': 'Hardware',
    'Home Retail': 'Home',
    'Nursery Retail': 'Nursery',
    'Office Retail': 'Office',
    'Other Retail': 'Other',
    'Pet Retail': 'Pet',
    'Vision Retail': 'Vision',

    'Security': 'Security',
    'Solar Energy': 'Solar Energy',
    'Sporting': 'Sporting',
    'Survey': 'Survey',
    'Telecommunication': 'Telecommunication',
    'Tours': 'Tourism',
    'Trade Services': 'Trade Services',
    'Travel': 'Travel',
    'Veterinary': 'Veterinary'
  },
  regionList: {
    'au': 'Australia', 'as': 'Asia', 'nz/oc': 'New Zealand', 'eu': 'Europe', 'na': 'North America', 'sa': 'South America', 'ma-sp': 'Middle East', 'af': 'Africa', 'uk': 'England'
  },
  lanList: {
    'af': 'Afrikaans',
    'ak': 'Akan',
    'sq': 'Albanian',
    'am': 'Amharic',
    'ar': 'Arabic',
    'hy': 'Armenian',
    'as': 'Assamese',
    'asa': 'Asu',
    'az': 'Azerbaijani',
    'bm': 'Bambara',
    'eu': 'Basque',
    'be': 'Belarusian',
    'bem': 'Bemba',
    'bez': 'Bena',
    'bn': 'Bengali',
    'bs': 'Bosnian',
    'bg': 'Bulgarian',
    'my': 'Burmese',
    'ca': 'Catalan',
    'tzm': 'Central Morocco Tamazight',
    'chr': 'Cherokee',
    'cgg': 'Chiga',
    'zh': 'Chinese',
    'kw': 'Cornish',
    'hr': 'Croatian',
    'cs': 'Czech',
    'da': 'Danish',
    'nl': 'Dutch',
    'ebu': 'Embu',
    'en': 'English',
    'eo': 'Esperanto',
    'et': 'Estonian',
    'ee': 'Ewe',
    'fo': 'Faroese',
    'fil': 'Filipino',
    'fi': 'Finnish',
    'fr': 'French',
    'ff': 'Fulah',
    'gl': 'Galician',
    'lg': 'Ganda',
    'ka': 'Georgian',
    'de': 'German',
    'el': 'Greek',
    'gu': 'Gujarati',
    'guz': 'Gusii',
    'ha': 'Hausa',
    'haw': 'Hawaiian',
    'he': 'Hebrew',
    'hi': 'Hindi',
    'hu': 'Hungarian',
    'is': 'Icelandic',
    'ig': 'Igbo',
    'id': 'Indonesian',
    'ga': 'Irish',
    'it': 'Italian',
    'ja': 'Japanese',
    'kea': 'Kabuverdianu',
    'kab': 'Kabyle',
    'kl': 'Kalaallisut',
    'kln': 'Kalenjin',
    'kam': 'Kamba',
    'kn': 'Kannada',
    'kk': 'Kazakh',
    'km': 'Khmer',
    'ki': 'Kikuyu',
    'rw': 'Kinyarwanda',
    'kok': 'Konkani',
    'ko': 'Korean',
    'khq': 'Koyra Chiini',
    'ses': 'Koyraboro Senni',
    'lag': 'Langi',
    'lv': 'Latvian',
    'lt': 'Lithuanian',
    'luo': 'Luo',
    'luy': 'Luyia',
    'mk': 'Macedonian',
    'jmc': 'Machame',
    'kde': 'Makonde',
    'mg': 'Malagasy',
    'ms': 'Malay',
    'ml': 'Malayalam',
    'mt': 'Maltese',
    'gv': 'Manx',
    'mr': 'Marathi',
    'mas': 'Masai',
    'mer': 'Meru',
    'mfe': 'Morisyen',
    'naq': 'Nama',
    'ne': 'Nepali',
    'nd': 'North Ndebele',
    'nb': 'Norwegian Bokmål',
    'nn': 'Norwegian Nynorsk',
    'nyn': 'Nyankole',
    'or': 'Oriya',
    'om': 'Oromo',
    'ps': 'Pashto',
    'fa': 'Persian',
    'pl': 'Polish',
    'pt': 'Portuguese',
    'pa': 'Punjabi',
    'ro': 'Romanian',
    'rm': 'Romansh',
    'rof': 'Rombo',
    'ru': 'Russian',
    'rwk': 'Rwa',
    'saq': 'Samburu',
    'sg': 'Sango',
    'seh': 'Sena',
    'sr': 'Serbian',
    'sn': 'Shona',
    'ii': 'Sichuan Yi',
    'si': 'Sinhala',
    'sk': 'Slovak',
    'sl': 'Slovenian',
    'xog': 'Soga',
    'so': 'Somali',
    'es': 'Spanish',
    'sw': 'Swahili',
    'sv': 'Swedish',
    'gsw': 'Swiss German',
    'shi': 'Tachelhit',
    'dav': 'Taita',
    'ta': 'Tamil',
    'te': 'Telugu',
    'teo': 'Teso',
    'th': 'Thai',
    'bo': 'Tibetan',
    'ti': 'Tigrinya',
    'to': 'Tonga',
    'tr': 'Turkish',
    'uk': 'Ukrainian',
    'ur': 'Urdu',
    'uz': 'Uzbek',
    'vi': 'Vietnamese',
    'vun': 'Vunjo',
    'cy': 'Welsh',
    'yo': 'Yoruba',
    'zu': 'Zulu'
  },
  languageList: {
    'en': 'English',
    'zh': 'Chinese',
    'ko': 'Korean',
    'es': 'Spanish',
    'id': 'Indonesian'
  },
  skipBtnText: {
    'en': 'No Thanks',
    'zh': '不, 谢谢',
    'fr': 'Non merci',
    'ko': '고마워',
    'es': 'No, gracias',
    'id': 'Tidak terima kasih'
  },
  dateTools: {
    dayAbbreviation: dayAbbreviation,
    dayList: dayList,
    monthList: monthList,
    monthLongList: monthLongList,
    searchDateRangeOptions: {today: 'Today', yesterday: 'Yesterday', last_30_day: 'Last 30 Days', this_month: 'This Month', last_month: 'Last Month', custom: 'Custom'},
    searchDateAllRangeOptions: {all: 'All', today: 'Today', yesterday: 'Yesterday', last_30_day: 'Last 30 Days', this_month: 'This Month', last_month: 'Last Month', custom: 'Custom'},
    enDateFormat: {
      formatDisplay (date) {
        return `${dayList[date.getDay()]}, ${monthList[date.getMonth()]} ${date.getDate()}`
      },
      formatMonth (date) {
        return `${monthLongList[date.getMonth()]} ${date.getFullYear()}`
      },
      getWeekDayArray (firstDayOfWeek) {
        let beforeArray = []
        let afterArray = []
        for (let i = 0; i < dayAbbreviation.length; i++) {
          if (i < firstDayOfWeek) {
            afterArray.push(dayAbbreviation[i])
          } else {
            beforeArray.push(dayAbbreviation[i])
          }
        }
        return beforeArray.concat(afterArray)
      },
      getMonthList () {
        return monthList
      }
    },
    searchDateRangeToFromTo (val) {
      let result = {fromDate: '', toDate: ''}
      const getLastDaysDate = function (days, firstDay, months) {
        const date = new Date()
        let last = new Date(date.getTime() - (days * 24 * 60 * 60 * 1000))
        if (months) {
          last = new Date(date.getFullYear(), date.getMonth() + months - 1, 0)
        }
        let day = last.getDate()
        const month = last.getMonth() + 1
        const year = last.getFullYear()
        // return year + '-' + month + '-' + day
        if (firstDay === true) {
          day = 1
        }
        return year + '-' + month + '-' + day
      }

      switch (val) {
        case 'today':
          result.fromDate = getLastDaysDate(0)
          result.toDate = getLastDaysDate(0)
          break
        case 'yesterday':
          result.fromDate = getLastDaysDate(1)
          result.toDate = getLastDaysDate(1)
          break
        case 'last_7_day':
          result.fromDate = getLastDaysDate(6)
          result.toDate = getLastDaysDate(0)
          break
        case 'last_28_day':
          result.fromDate = getLastDaysDate(27)
          result.toDate = getLastDaysDate(0)
          break
        case 'last_56_day':
          result.fromDate = getLastDaysDate(55)
          result.toDate = getLastDaysDate(0)
          break
        case 'last_30_day':
          result.fromDate = getLastDaysDate(29)
          result.toDate = getLastDaysDate(0)
          break
        case 'this_month':
          result.fromDate = getLastDaysDate(0, true)
          result.toDate = getLastDaysDate(0)
          break
        case 'last_month':
          result.fromDate = getLastDaysDate(0, true, 1)
          result.toDate = getLastDaysDate(0, false, 1) // always last day
          break
        case 'custom':
        case 'all':
          result.fromDate = ''
          result.toDate = ''
          break
        default:
          result.fromDate = getLastDaysDate(0)
          result.toDate = getLastDaysDate(0)
          break
      }
      return result
    }
  }
}



// WEBPACK FOOTER //
// ./src/config/commonVariable.js